var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("detail", {
        attrs: {
          prop: _vm.i18n.lbl_destination_asset(),
          value: _vm.destinationAsset
        }
      }),
      _vm._v(" "),
      _vm.wallet
        ? _c("detail", {
            attrs: {
              prop: _vm.i18n.lbl_wallet(),
              value: _vm.wallet,
              copiable: true
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hash
        ? _c("detail", {
            attrs: {
              prop: _vm.i18n.lbl_hash(),
              value: _vm.hash,
              copiable: true
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.orderId && _vm.internalHash
        ? _c("detail", {
            attrs: {
              prop: _vm.i18n.lbl_internal_hash(),
              value: _vm.internalHash,
              copiable: true
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.orderId
        ? _c("detail", {
            attrs: {
              prop: _vm.i18n.lbl_order_id(),
              value: _vm.orderId,
              copiable: true
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.orderAmount
        ? _c("detail", {
            attrs: { prop: _vm.i18n.lbl_order_amount(), value: _vm.orderAmount }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.orderNetwork
        ? _c("detail", {
            attrs: {
              prop: _vm.i18n.lbl_order_network(),
              value: _vm.orderNetwork
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("detail", {
        attrs: {
          prop: _vm.i18n.lbl_amount(),
          value: _vm.i18n.c(_vm.tx.amount) + " " + _vm.formatToken
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: {
          prop: _vm.i18n.lbl_fixed_fee(),
          value: _vm.i18n.c(_vm.tx.fixedFee) + " " + _vm.formatToken
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: {
          prop: _vm.i18n.lbl_percent_fee(),
          value: _vm.i18n.c(_vm.tx.percentFee) + " " + _vm.formatToken
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: {
          prop: _vm.i18n.lbl_destination_amount(),
          value: _vm.i18n.c(_vm.tx.destinationAmount) + " " + _vm.formatToken
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: { prop: _vm.i18n.lbl_date(), value: _vm.tx.date }
      }),
      _vm._v(" "),
      _c("CheckSignList", { attrs: { id: _vm.internalId, isHistory: true } }),
      _vm._v(" "),
      _vm.showDelay
        ? _c("WithdrawalDelay", {
            attrs: { tx: _vm.localList },
            on: {
              close: _vm.closeDelay,
              refetchList: function($event) {
                return _vm.$emit("refetchList")
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.amlValues && _vm.aviliableAml
        ? _c("Aml", { attrs: { score: _vm.riskScore, values: _vm.amlValues } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38cbe9d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38cbe9d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/history/index/components/Details.Withdraw.vue
// module id = H20n
// module chunks = 1